import { Picture } from '@/types/model';

export const generateUrl = (picture: Picture, format: string): string => {
  return `${picture.urls[format]}?ts=${picture.lastUpdateTimestamp ?? ''}`;
};
